import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'bloqueio-sistema');

const bloqueioSistemaActions = {
  pesquisar: { method: 'GET', url: `${basePath}` },
  pesquisarPagamento: { method: 'GET', url: `${basePath}/integracao-pagamento` },
};

export default resource => resource(`${basePath}`, {}, bloqueioSistemaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/bloqueio-sistema.js